export default __webpack_public_path__ + "static/media/1367.5d7af711.png";